// import { FieryRecordSave, FieryRecordRemove, FieryRecordBuild } from '@/modules/fiery-vuex/src'
import { FieryRecordSave, FieryRecordRemove } from 'fiery-vuex'

export class Document {
    createdBy: string | null = null
    updatedBy: string | null = null
    updatedAt: Date | null = null
    createdAt: Date | null = null
    managedBy: Array<string> = []
    editableBy: Array<string> = []
    users: Array<string> = []

    getCurrentEpoch(){
        return Math.floor(Date.now() / 1000)
    }

    async updateUserPerms(key, userID, add = true, save = true ) {
        if (!this[ key ]) this[key] = []

        if (add) {
            this[key].push(userID)
        } else {
            this[key] = this[key].filter(existID => existID !== userID)
        }

        return save ? this.save() : true
    }
    
    updateUsers(userID, add = true, save = true) {
        return this.updateUserPerms('users', userID, add, save)
    }

    updateManagedBy(userID, add = true, save = true) {
        return this.updateUserPerms('managedBy', userID, add, save)
    }

    updateEditableBy(userID, add = true, save = true) {
        return this.updateUserPerms('editableBy', userID, add, save)
    }

    create(userID) {
        this.createdBy = userID
        this.updatedBy = userID
        this.createdAt = new Date()
        this.updatedAt = new Date()
        this.users = [userID]
        return this.save()
    }

    update(userID) {
        if( ! this.createdBy ){
            return this.create(userID)
        }

        this.updatedBy = userID
        this.updatedAt = new Date()
        return this.save()
    }

    save: FieryRecordSave
    remove: FieryRecordRemove
}

export const DocumentOptions = {
    shared: true,
    type: Document,
    include: ["createdAt", "updatedAt", "createdBy", "updatedBy", "users", "managedBy", "editableBy"],
    exclude: ["exists", "id"], // Only required if not using include but add for clarification
    timestamps: ["updatedAt", "createdAt"],
    record: true,
    recordOptions: {
        save: "save",
        remove: "remove"
    },
    key: "id",
    map: true,
    propExists: "exists"
}

export const DocumentOptionsNoMAP = {
    shared: true,
    type: Document,
    include: ["createdAt", "updatedAt", "createdBy", "updatedBy", "users", "managedBy", "editableBy"],
    exclude: ["exists", "id"], // Only required if not using include but add for clarification
    timestamps: ["updatedAt", "createdAt"],
    record: true,
    recordOptions: {
        save: "save",
        remove: "remove"
    },
    key: "id",
    map: false,
    propExists: "exists"
}

export default DocumentOptions